import { lazyLoad } from "../../../utils/loadable";

export const AdminUserSettingsPage = lazyLoad(
  () => import("./index"),
  (module) => module.default
);
